const bazarListDe = {
	banner: {
		title: 'Bazare',
		subtitle: 'Einkaufen in tausenden traditionellen Märkten',
		breadcrumbLabel: 'Bazare',
		currentPlaceholder: 'Lebensmittel suchen...'
	},
	filter: {
		title: 'Filteroptionen',
		searchPlaceholder: 'Bazare suchen...',
		district: 'Distrikt',
		upazilla: 'Upazila',
		size: 'Bazar-Größe',
		sortBy: 'Sortieren nach',
		sortOptions: {
			name: 'Name',
			storeCount: 'Anzahl der Läden',
			rating: 'Bewertung',
			visitors: 'Beliebtheit'
		},
		clearShort: 'Löschen',
		clearAll: 'Alle löschen',
		activeFilters: 'Aktive Filter:',
		labels: {
			search: 'Suche',
			district: 'Distrikt',
			upazilla: 'Upazila',
			size: 'Größe'
		}
	},
	results: {
		foundSuffix: 'Bazare gefunden',
		none: 'Keine Bazare gefunden',
		page: 'Seite'
	},
	empty: {
		title: 'Keine Bazare entsprechen Ihrer Suche',
		subtitle: 'Versuchen Sie andere Filter oder löschen Sie alle Filter',
		clear: 'Alle Filter löschen'
	},
	card: {
		stores: 'Läden',
		dailyVisitors: 'Tägliche Besucher',
		specialties: 'Spezialitäten:',
		details: 'Details',
		visit: 'Besuchen'
	},
	dialog: {
		title: 'Glückwunsch!',
		selected: 'Ihr Bazar wurde ausgewählt',
		instruction: 'Ihr aktueller Bazar ist jetzt ausgewählt. Wählen Sie unten eine Kategorie:',
		categoryPrompt: 'Was möchten Sie einkaufen?',
		bottomNotePrefix: 'Diese Produkte werden bezogen von',
		bottomNoteSuffix: '',
		close: 'Später ansehen'
	}
};

export default bazarListDe;


